export default __webpack_public_path__ + "static/media/lp-sec05_bg700.8ec4a218.png";